import { BaseContainerPanel, ContainerPanel } from './container'
import { ImageContainerPanel, ImagePanel } from './image'
import { TextPanel } from './text'
import { ButtonContainerPanel } from './button-container'
import { CarouselPanel } from "./carousel";

import type { PanelType } from '../layouts/utils'

type Panels = { [panelType in PanelType]: (props: any) => JSX.Element }

export const getPanel = (panelType: PanelType) => {
	const panels: Panels = {
		baseContainerPanel: BaseContainerPanel,
		containerPanel: ContainerPanel,
		textPanel: TextPanel,
		buttonsContainerPanel: ButtonContainerPanel,
		imagePanel: ImagePanel,
		imageContainerPanel: ImageContainerPanel,
		carouselPanel: CarouselPanel,
	}

	const panel = panels[panelType]
	return panel ?? null
}
